import { useQuery } from 'react-query';
import { fetchOwnedNft, fetchOwnedNfts } from 'utils/platformPublicApi';
import { ApiPaginatedResults, OwnedNft } from 'utils/types';
import useAllPages from './useAllPages';

export const useAllOwnedNfts = (
  address: string | null,
  chainIds: number[],
  contracts: string[] | null,
  includeMetadata = true,
  queryConfig = {}
) => {
  return useAllPages<OwnedNft, ApiPaginatedResults<OwnedNft>>(
    ['owned', 'all', address, chainIds, contracts],
    (cursor: string | undefined) =>
      fetchOwnedNfts(address ?? '', chainIds, contracts ?? [], undefined, undefined, cursor),
    {
      enabled: Boolean(address),
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 15, // 15 minutes
      refetchOnWindowFocus: false,
      ...queryConfig,
    }
  );
};

export const useToken = (
  contract: string,
  tokenId: string | number,
  chain: number,
  queryConfig = {}
) => {
  return useQuery(
    ['token', contract, tokenId, chain],
    async () => {
      return fetchOwnedNft(contract, tokenId, chain);
    },
    {
      enabled: Boolean(contract && tokenId && chain),
      // the ownership of a token can change so we cannot cache it for a long time like the metadata alone
      cacheTime: 1000 * 60 * 5, // 5 minutes
      ...queryConfig,
    }
  );
};
